"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasisTheoryValidationError = void 0;

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = Reflect.construct(cls, Array.from(arguments));
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    return instance;
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

class BasisTheoryValidationError extends _extendableBuiltin(Error) {
  constructor(message, details, validation) {
    super(message);
    this.details = details;
    this.validation = validation;
    this.name = 'BasisTheoryValidationError';
    Object.setPrototypeOf(this, BasisTheoryValidationError.prototype);
  }

}

exports.BasisTheoryValidationError = BasisTheoryValidationError;